import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { getCompanyUsers, editCompanyUsers, createCompanyUsers, showCompanyUsers, deleteCompanyUser, activateCompanyUser } from "../../controllers/apiCompanyUsers";
import { formatDecimal, formatMoney, formatDate, formatDateTime, formatText } from "../../utils/formatters";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { encryptText } from '../../controllers/api';
import ModalCompanyUsers from "./ModalCompanyUsers";
import ModalConfirmation from "../Modals/ModalConfirmation";
import $ from "jquery";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";

// Import estilos y botones
import "datatables.net-dt/css/dataTables.dataTables.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";

import JSZip from "jszip";
window.JSZip = JSZip;

DataTable.use(DT);

export default function ListCompanyUsers() {
  const navigate = useNavigate();
  var responseCache = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalOpenCompanyUsers, setModalOpenCompanyUsers] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [companyUsersIdToAction, setCompanyUserIdToAction] = useState(null);
  const [filterType, setFilterType] = useState("");
  const [userIdToAction, setUserIdToAction] = useState(null);
  const { user } = useContext(AuthContext);
  const rol = user?.rol;

  useEffect(() => {
    const table = $("#ListCompanyUsersDt").DataTable();

    // Evento para botón Editar
    $("#ListCompanyUsersDt tbody").on("click", "button.btn-edit", function () {
      const id = $(this).data("id");
      handleEdit(id);
    });

    $("#ListCompanyUsersDt tbody").on("click", "button.btn-view", function () {
        const id = $(this).data("id");
        handleOpenModalCompanyUsers(id);
      });

    $("#ListCompanyUsersDt tbody").on("click", "button.btn-delete", function () {
      const id = $(this).data("id");
      const nombre = $(this).data("nombre");
      const action = $(this).data("action");
      handleOpenModal(id, nombre, action);
    });

    return () => {
      $("#ListCompanyUsersDt tbody").off("click", "button.btn-edit");
      $("#ListCompanyUsersDt tbody").off("click", "button.btn-view");
      $("#ListCompanyUsersDt tbody").off("click", "button.btn-delete");
    };
  }, []);

  const handleEdit = async (id) => {
    try {
      const hash = encryptText(id.toString());
      navigate(`/company-users/edit/?id=${encodeURIComponent(hash)}`);
    } catch (error) {
      toast.error("Error al cargar usuario de la empresa");
      console.error(error);
    }
  };

  const handleOpenModalCompanyUsers = async (id) => {
    try {
      const data = await showCompanyUsers(id);
      setCompanyUserIdToAction(data);
      setModalOpenCompanyUsers(true);
    } catch {
      toast.error("Error al obtener detalles del usuario.");
    }
  };

  const handleCloseModalCompanyUsers = () => setModalOpenCompanyUsers(false);

  const handleOpenModal = (id, nombre, action) => {
    setUserIdToAction({ id, nombre, action });
    setModalOpen(true);
  };

  const handleCloseModal = () => setModalOpen(false);

  const handleConfirm = () => {
    if (userIdToAction) {
      handleAction(userIdToAction.id, userIdToAction.action);
      setModalOpen(false);
    }
  };

  const handleAction = async (id, action) => {
    try {
      let data;
      if (action === 'delete') data = await deleteCompanyUser(id);
      else data = await activateCompanyUser(id);

      toast.success(data.mensaje || 'Acción realizada con éxito', { onClose: refreshCompanyUsers });
    } catch (err) {
      console.error(err);
      toast.error("Error al actualizar el usuario");
    }
  };

  const refreshCompanyUsers = async () => {
    try {
      const data = await getCompanyUsers();
      const table = $('#ListCompanyUsersDt').DataTable();
      table.clear();
      table.rows.add(data);
      table.draw();
    } catch (error) {
      console.error("Error cargando usuarios:", error);
      toast.error("Error al recargar la lista de usuarios");
    }
  };

  const actionSearch = () => {
    const table = $("#ListCompanyUsersDt").DataTable();
    table.clear();
    table.search("");
    table.columns().search("");
    table.ajax.reload();
  };

  return (
    <div className="mx-auto w-full">
      <ToastContainer />
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12">
          <div className="relative bg-white flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            {/* Header */}
            <div className="rounded-t bg-white mb-0 px-6 py-6 flex justify-between items-center border-b">
              <h6 className="text-blueGray-700 text-xl font-bold">Lista de Usuarios</h6>
              <div className="flex items-center space-x-3">
                <div className="flex items-center flex-wrap gap-2">
                  <h3 className="text-blueGray-700 font-bold mr-3 whitespace-nowrap">Buscar por:</h3><br/>
                  {/* SELECT PRINCIPAL — (2026-05-13) Para admin/auditor el
                      filtro reemplaza Activos/Inactivos por 4 categorias
                      (Internos x Activo/Inactivo, Clientes x Activo/Inactivo)
                      mas "Todos" que combina las cuatro. Para otros roles se
                      mantiene el set simple (Activos/Inactivos/Todos). */}
                  <select id="filter_type" className="border p-2 rounded" value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                    <option value="all">Todos</option>
                    {(rol === 'admin' || rol === 'auditor') ? (
                      <>
                        <option value="internal_active">Internos activos</option>
                        <option value="internal_inactive">Internos inactivos</option>
                        <option value="client_active">Usuarios clientes activos</option>
                        <option value="client_inactive">Usuarios clientes inactivos</option>
                      </>
                    ) : (
                      <>
                        <option value="active">Activos</option>
                        <option value="inactive">Inactivos</option>
                      </>
                    )}
                  </select>
                  <button
                    className="bg-twilight-indigo-600 hover:bg-twilight-indigo-500 text-white font-bold py-2 px-4 rounded"
                    onClick={actionSearch}>
                    Buscar
                  </button>
                  {(rol != "visor" && rol != "auditor") && (
                    <button
                      className="bg-twilight-indigo-600 hover:bg-twilight-indigo-500 text-white font-bold px-4 py-2 rounded"
                      onClick={() => navigate("/company-users/create")}>
                      Crear Usuario
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Tabla */}
            <div className="block w-full overflow-x-auto px-4 py-4">

              <DataTable
                id="ListCompanyUsersDt"
                className="table-auto w-full"
                columns={[
                  { title: "Nombre", data: "nombre", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "Correo", data: "email", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  // (2026-05-13) Para admin/auditor exponemos RIF y Empresa
                  // asociada al usuario (similar al detalle de proformas).
                  // Para usuarios internos (admin/auditor) el cliente nested
                  // viene en null vía @post_dump → mostramos "Interno".
                  ...((rol === 'admin' || rol === 'auditor') ? [
                    {
                      title: "RIF (Afiliada)",
                      // (2026-05-25 v13) Rename `cliente` → `empresa`
                      // (semánticamente correcto: es la Empresa donde
                      // trabaja el usuario, no un ClienteFinal).
                      data: "empresa",
                      className: "dt-center",
                      render: (data, type, row) => {
                        if (row.rol === 'admin' || row.rol === 'auditor') {
                          return '<span class="text-blueGray-400 text-xs italic">Interno</span>';
                        }
                        return data && data.rif ? formatText(data.rif) : '<span class="text-blueGray-400 text-xs">—</span>';
                      }
                    },
                    {
                      title: "Empresa (Afiliada)",
                      data: "empresa",
                      render: (data, type, row) => {
                        if (row.rol === 'admin' || row.rol === 'auditor') {
                          return '<span class="text-blueGray-400 text-xs italic">Optimus Invoice</span>';
                        }
                        return data && data.nombre_empresa ? formatText(data.nombre_empresa) : '<span class="text-blueGray-400 text-xs">—</span>';
                      }
                    },
                  ] : []),
                  {
                    title: "Rol",
                    data: "rol",
                    className: "dt-center",
                    render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  {
                    title: "Debe cambiar clave",
                    data: "must_change_password",
                    className: "dt-center",
                    render: (data, type, row) => {
                      if (!data){
                        return '<i class="fas fa-circle text-red-500 mr-2"></i> ' + formatText('No');
                      }else{
                        return '<i class="fas fa-circle text-emerald-500 mr-2"></i> ' + formatText('Si');
                      }
                    }
                  },
                  {
                    title: "Creado",
                    data: "created_at",
                    className: "dt-center",
                    render: (data, type, row) => {
                      return formatDateTime(data);
                    }
                  },
                  {
                    title: "Estado",
                    data: "activo",
                    className: "dt-center",
                    render: (data, type, row) => {
                      if (!data){
                        return '<i class="fas fa-circle text-red-500 mr-2"></i> ' + formatText('No');
                      }else{
                        return '<i class="fas fa-circle text-emerald-500 mr-2"></i> ' + formatText('Si');
                      }
                    }
                  },
                  // (2026-05-13) Columnas de Integrador visibles solo para admin/auditor.
                  ...((rol === 'admin' || rol === 'auditor') ? [
                    {
                      title: "Integrador",
                      data: "es_integrador",
                      className: "dt-center",
                      render: (data, type, row) => {
                        if (!data) {
                          return '<i class="fas fa-circle text-red-500 mr-2"></i> ' + formatText('No');
                        } else {
                          return '<i class="fas fa-circle text-emerald-500 mr-2"></i> ' + formatText('Si');
                        }
                      }
                    },
                    {
                      title: "Aplicativo",
                      data: "aplicativo",
                      className: "dt-center",
                      render: (data) => formatText(data || "")
                    },
                    {
                      title: "Versión",
                      data: "version_app",
                      className: "dt-center",
                      render: (data) => formatText(data || "")
                    },
                    {
                      title: "Origen",
                      data: "origen",
                      render: (data) => {
                        if (!data) return '<span class="text-blueGray-400 text-xs">—</span>';
                        const txt = String(data);
                        return txt.length > 40 ? `<span title="${txt}">${txt.slice(0, 40)}…</span>` : txt;
                      }
                    },
                  ] : []),
                  {
                    title: "Acciones",
                    data: "activo",
                    orderable: false,
                    searchable: false,
                    className: 'no-export',
                    render: (data, type, row) => {
                      const viewBtn = `<button class="btn-view px-2 py-1 text-gray-700" data-id="${row.id}"><i class="fa-solid fa-lg fa-expand"></i></button>`;
                      const editBtn = `<button class="btn-edit px-2 py-1 text-blue-600" data-id="${row.id}"><i class="fa-solid fa-lg fa-pen-to-square"></i></button>`;
                      const toggleBtn = data
                        ? `<button class="btn-delete px-2 py-1 text-red-600" data-id="${row.id}" data-nombre="${row.nombre}" data-action="delete"><i class="fa-regular fa-rectangle-xmark fa-lg"></i></button>`
                        : `<button class="btn-delete px-2 py-1 text-green-600" data-id="${row.id}" data-nombre="${row.nombre}" data-action="active"><i class="fa-regular fa-square-check fa-lg"></i></button>`;
                      if (rol == "visor" || rol == "auditor" || rol == "operador"){
                        return `<div style="display:flex;justify-content:center;align-items:center;gap:0.25rem;white-space:nowrap;">${viewBtn}</div>`; //${toggleBtn}
                      }else{
                        return `<div style="display:flex;justify-content:center;align-items:center;gap:0.25rem;white-space:nowrap;">${viewBtn}${editBtn}${toggleBtn}</div>`; //${toggleBtn}
                      }
                    }
                  }
                ]}

                options={{
                  dom: //B = Buttons, l = LengthMenu (mostrar X registros), f = Filtro (search), t = Tabla, i = Info (mostrando de X a Y de Z), p = Paginación
                    "<'row'<'col-sm-12 text-start'B>>" +                // Fila 2: botones ocupando todo el ancho
                    "<'row'<'col-sm-6 text-end'l><'col-sm-6'f>>" +    // Fila 1: lengthMenu izquierda, filtro derecha
                    "<'row'<'col-sm-12'tr>>" +               // Fila 3: tabla
                    "<'row'<'col-sm-5 text-start'i><'col-sm-7 text-end'p>>",     // Fila 4: info izquierda, paginación derecha
                  serverSide: true,
                  processing: true,
                  ajax: async (dataTablesParams, callback) => {
                    try {
                      const searchValue = dataTablesParams.search?.value?.toLowerCase() || '';
                      const page = Math.floor(dataTablesParams.start / dataTablesParams.length) + 1;
                      const per_page = dataTablesParams.length;
                      const query = {
                        page,
                        per_page
                      };
                      // (2026-05-13) Mapeo del filtro UI -> query params backend.
                      //   all              -> sin tipo_usuario, include_inactive=true
                      //   active           -> include_inactive=false (legacy)
                      //   inactive         -> activo=false
                      //   internal_active  -> tipo_usuario=interno, activo=true
                      //   internal_inactive-> tipo_usuario=interno, activo=false
                      //   client_active    -> tipo_usuario=cliente, activo=true
                      //   client_inactive  -> tipo_usuario=cliente, activo=false
                      const seleccion = $('#filter_type option:selected').val();
                      switch (seleccion) {
                        case 'active':
                          query.include_inactive = false;
                          break;
                        case 'inactive':
                          query.activo = false;
                          break;
                        case 'internal_active':
                          query.tipo_usuario = 'interno';
                          query.activo = true;
                          break;
                        case 'internal_inactive':
                          query.tipo_usuario = 'interno';
                          query.activo = false;
                          break;
                        case 'client_active':
                          query.tipo_usuario = 'cliente';
                          query.activo = true;
                          break;
                        case 'client_inactive':
                          query.tipo_usuario = 'cliente';
                          query.activo = false;
                          break;
                        case 'all':
                        default:
                          query.include_inactive = true;
                          break;
                      }
                      //console.log('query: ', query);
                      if (searchValue == ''){
                        //console.log('if');
                        // Pasamos los filtros al servicio
                        //const response = await getInvoices(query);
                        const response = await getCompanyUsers(query);
                        // Respaldar response anterior
                        responseCache = response;
                        //console.log('responseCache: ', responseCache);

                        // Aseguramos que la estructura esperada esté presente
                        var { data, total } = response;
                      }else{
                        //console.log('else');
                        const CAMPOS_EXCLUIDOS = [
                          "created_at",
                          "updated_at"
                        ];
                        //console.log('responseCache: ', responseCache);
                        var filteredData = responseCache.data.filter(item =>
                          Object.entries(item).some(([key, value]) => {
                            // Excluir campos internos
                            if (CAMPOS_EXCLUIDOS.includes(key)) return false;
                            if (!value) return false;
                            return String(value).toUpperCase().includes(searchValue.toUpperCase());
                          })
                        );
                        //console.log('filteredData: ', filteredData);
                        var data = filteredData;
                        var total = filteredData.length;
                        //var { data, total } = responseCache;
                      }
                      callback({
                        draw: dataTablesParams.draw,
                        recordsTotal: total,
                        recordsFiltered: total,
                        data: data,
                      });
                    } catch {
                      callback({
                        draw: dataTablesParams.draw,
                        recordsTotal: 0,
                        recordsFiltered: 0,
                        data: []
                      });
                    }
                  },
                  paging: true,
                  searching: true,
                  ordering: true,
                  info: true,
                  responsive: true,
                  pageLength: 20,         // cantidad inicial por página
                  lengthMenu: [20, 50, 100], // opciones en el desplegable, false para oculta el selector
                  buttons: [
                    {
                      extend: "collection",
                      text: "Exportar",
                      className: "bg-slate-700 hover:bg-slate-600 text-white font-bold py-2 px-4 rounded",
                      buttons: [
                        {
                          extend: "copyHtml5",
                          text: "Copiar",
                          title: "Lista de usuarios"   // nombre del documento en el portapapeles
                        },
                        {
                          extend: "excelHtml5",
                          text: "Excel",
                          title: "Lista de usuarios",  // título dentro del archivo
                          filename: "Lista_usuarios",   // nombre del archivo generado (sin extensión)
                          exportOptions: {
                            columns: ':not(.no-export)'
                          }
                        },
                        {
                          extend: "csvHtml5",
                          text: "CSV",
                          title: "Lista de usuarios",
                          filename: "Lista_usuarios",
                          exportOptions: {
                            columns: ':not(.no-export)'
                          }
                        },
                        {
                          extend: "pdfHtml5",
                          text: "PDF",
                          title: "Lista de usuarios",
                          filename: "Lista_usuarios",
                          exportOptions: {
                            columns: ':not(.no-export)'
                          },
                          orientation: "landscape",
                          //orientation: "landscape",   // opcional
                          //pageSize: "A4"              // opcional
                        },
                        {
                          extend: "print",
                          text: "Imprimir",
                          title: "Lista de usuarios",
                          exportOptions: {
                            columns: ':not(.no-export)'
                          }
                        },
                      ]
                    }
                  ],
                  language: {
                    decimal: ",",
                    thousands: ".",
                    lengthMenu: "Mostrar _MENU_ registros por página",
                    zeroRecords: "No se encontraron resultados",
                    info: "Mostrando de _START_ a _END_ de _TOTAL_ registros",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrado de _MAX_ registros totales)",
                    search: "Buscar:",
                    paginate: {
                      first: "Primero",
                      last: "Último",
                      next: "Siguiente",
                      previous: "Anterior"
                    }
                  },
                }}
              />

            </div>
          </div>
        </div>
        <ModalCompanyUsers
          isOpen={modalOpenCompanyUsers}
          onClose={handleCloseModalCompanyUsers}
          companyUser={companyUsersIdToAction}
        />

        {/* Modales */}
        <ModalConfirmation
          isOpen={modalOpen}
          onClose={handleCloseModal}
          onConfirm={handleConfirm}
          message={`¿Estás seguro de que deseas ${userIdToAction?.action === 'delete' ? 'desactivar' : 'activar'} al usuario ${userIdToAction?.nombre || ''}?`}
        />
      </div>
    </div>
  );
}
